/**
 * /advertisers/caps — advertiser cap configuration (feature #147).
 *
 * Flat-file TanStack route: dots become path separators, so
 * `advertisers.caps.tsx` maps to `/advertisers/caps`. The route accepts an
 * `?advertiser=<id>` search param so operators can deep-link into a specific
 * advertiser's cap list.
 *
 * Mirrors the shape of `advertisers.portal.tsx` so the central wire-up can
 * import this module with the same pattern.
 */

import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AdvertiserCapsPage } from "@/features/advertiser-caps/AdvertiserCapsPage";

// ---------------------------------------------------------------------------
// Route declaration.
// ---------------------------------------------------------------------------

interface AdvertiserCapsSearch {
	advertiser?: string;
}

export const advertisersCapsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/advertisers/caps",
	validateSearch: (raw: Record<string, unknown>): AdvertiserCapsSearch => {
		const advertiser = raw.advertiser;
		if (typeof advertiser === "string" && advertiser.trim().length > 0) {
			return { advertiser: advertiser.trim() };
		}
		return {};
	},
	component: AdvertiserCapsPageRoute,
});

function AdvertiserCapsPageRoute() {
	const search = advertisersCapsRoute.useSearch() as AdvertiserCapsSearch;
	return <AdvertiserCapsPage initialAdvertiserId={search.advertiser ?? ""} />;
}

export default advertisersCapsRoute;

// Re-export the page for the registry wire-up to pick up.
export { AdvertiserCapsPage } from "@/features/advertiser-caps/AdvertiserCapsPage";
